export default function DesMoinesMistakesSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Mistakes Des Moines Travelers Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the top errors we see from Iowa applicants that cause passport delays and rejections.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            {
              num: "01",
              title: "Waiting Too Long to Start",
              desc: "Many Des Moines travelers assume 6–8 weeks is enough time. During peak seasons (summer, holidays), routine processing can stretch to 13+ weeks. Start your expedited application at least 4–6 weeks before travel.",
            },
            {
              num: "02",
              title: "Bad Passport Photos",
              desc: "The #1 reason for rejection. Photos with shadows, glasses, wrong background color, or incorrect size. Use a professional photo service in Des Moines and double-check against official requirements.",
            },
            {
              num: "03",
              title: "Visiting the Clerk Before Signing Up",
              desc: "If you need expedited service, you MUST sign up with Fast Passport Center BEFORE visiting the acceptance clerk. Once your documents enter the standard system, they cannot be retrieved for courier submission.",
            },
            {
              num: "04",
              title: "Wrong Name on Documents",
              desc: "Your passport application name must match your ID exactly. If you recently changed your name through marriage or divorce, bring legal documentation. Mismatched names cause instant delays.",
            },
            {
              num: "05",
              title: "Not Checking Passport Validity",
              desc: "Many countries require 6 months of validity beyond your travel date. Des Moines travelers flying to Europe, Asia, or South America should check requirements early — renewal is easier than emergency replacement.",
            },
            {
              num: "06",
              title: "Forgetting Parental Consent for Minors",
              desc: "Both parents typically must appear or provide notarized consent for children under 16. Des Moines families planning international travel should start child passport applications early to avoid last-minute issues.",
            },
          ].map((m, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-4">
                <span className="text-[#F6C344] font-bold text-lg font-mono flex-shrink-0">{m.num}</span>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}